import { fmtPct } from "@/lib/api";

const statusMap = {
  OPEN: { label: "MARKET OPEN", color: "#00E676" },
  PRE_OPEN: { label: "PRE-OPEN", color: "#FFB300" },
  CLOSED: { label: "MARKET CLOSED", color: "#FF3B30" },
  WEEKEND: { label: "WEEKEND", color: "#8A919E" },
  HOLIDAY: { label: "NSE HOLIDAY", color: "#8A919E" },
};

export function TopBar({ snapshot, connected }) {
  const market = snapshot?.market || {};
  const st = statusMap[market.status] || statusMap.CLOSED;
  const mode = snapshot?.mode || "PAPER";
  const kite = snapshot?.kite || {};
  const live = snapshot?.data_source === "LIVE";
  const feedConnected = snapshot?.feed_connected;
  const nInstr = snapshot?.instruments_subscribed || 0;

  return (
    <div className="glass sticky top-0 z-40 border-b border-edge px-4 pt-3 pb-2.5" data-testid="top-bar">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span
            className={`h-2 w-2 rounded-full ${market.is_open ? "pulse-dot" : ""}`}
            style={{ background: st.color }}
            data-testid="market-status-dot"
          />
          <div className="leading-none">
            <div className="text-[10px] font-semibold uppercase tracking-[0.15em]" style={{ color: st.color }} data-testid="market-status-text">
              {st.label}
            </div>
            <div className="mono text-[11px] text-muted2 mt-0.5">
              IST {market.ist_time || "--:--:--"}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <span
            className={`px-2 py-1 rounded-sm text-[10px] font-bold tracking-widest border ${
              mode === "LIVE" ? "border-neg text-neg" : "border-brand text-brand"
            }`}
            data-testid="mode-badge"
          >
            {mode}
          </span>
          <span
            className={`px-2 py-1 rounded-sm text-[10px] font-bold tracking-widest border ${
              connected ? "border-pos/40 text-pos" : "border-edge text-muted2"
            }`}
            data-testid="ws-status"
          >
            {connected ? "LIVE FEED" : "..."}
          </span>
        </div>
      </div>

      {live ? (
        <div className="mt-2 flex items-center gap-1.5 text-[10px] text-pos/90 bg-pos/10 border border-pos/20 rounded-sm px-2 py-1" data-testid="feed-banner">
          <span className="font-bold tracking-wider">● LIVE NSE TICKS</span>
          <span className="text-pos/70">— {nInstr} instruments {feedConnected ? "streaming" : "connecting…"}</span>
        </div>
      ) : (
        <div className="mt-2 flex items-center gap-1.5 text-[10px] text-warn/90 bg-warn/10 border border-warn/20 rounded-sm px-2 py-1" data-testid="sim-banner">
          <span className="font-bold tracking-wider">SIMULATED TICKS</span>
          <span className="text-warn/70">— {kite.logged_in ? "starting live feed…" : "log in to Kite for live market data"}</span>
        </div>
      )}
    </div>
  );
}
